import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const TextEditorStyled = styled.div`
    width: 300px;
    font-size: 13px;
    padding: 7px 3px;
    border: 1px solid #aaa;
    border-radius: 3px;
`;
const TextEditor = () => {
    const textRef = useRef(null);

    const [ CurrentNode, setCurrentNode ] = useState(null);

    useEffect(() => {
        let observer;
        const handleSelectionChange = () => {
            const selection = window.getSelection();
            if(!selection || selection.rangeCount === 0) {
                setCurrentNode(null);
                return;
            }
            const range = selection.getRangeAt(0);
            const currentNode = range.startContainer;

            // DOM 트리를 따라 올라가며 sup 또는 sub 확인
            let node = currentNode.noteType === Node.TEXT_NODE ? currentNode.parentNode : currentNode;
            while(node && node !== textRef.current) {
                switch (node.nodeName) {
                    case "SUP": setCurrentNode("SUP"); return; 
                    case "SUB": setCurrentNode("SUB"); return; 
                    default: node = node.parentNode;
                }
            }
            setCurrentNode(null);
        }

        const handleFocus = () => {
            observer = new MutationObserver(handleSelectionChange);
            observer.observe(textRef.current, {
                childList: true,
                subtree: true,
                characterData: true
            })
            document.addEventListener("selectionchange", handleSelectionChange);
        }
        const handleBlur = () => {
            if(observer) observer.disconnect();
            document.removeEventListener("selectionchange", handleSelectionChange);
        }
        const editor = textRef.current;
        editor.addEventListener("focus", handleFocus);
        editor.addEventListener("blur", handleBlur);
        return () => {
            if(observer) observer.disconnect();
            editor.removeEventListener("focus", handleFocus)
            editor.removeEventListener("blur", handleBlur);
            document.removeEventListener("selectionchange", handleSelectionChange);
        }
    },[])


    const wrapWithTag = (tag) => {
        const selection = window.getSelection();

        // 선택이 없거나, 범위가 설정되지 않은 경우 처리
        if (!selection || selection.rangeCount === 0) {
            const editor = textRef.current;
            const range = document.createRange();

            //  커서가 마지막 위치에 있다면 새 태그 추가
            range.selectNodeContents(editor);
            range.collapse(false);
            selection.addRange(range);
        }

        const range = selection.getRangeAt(0);
        
        let newNode;
        // 선택된 텍스트가 있는 경우
        if (!range.collapsed) {
            newNode = document.createElement(tag);
            newNode.appendChild(range.extractContents());
            range.insertNode(newNode);

            selection.removeAllRanges();

            // 커서를 태그 바로 뒤로 이동
            const newRange = document.createRange();
            
            // const textNode = document.createTextNode("\u200b");
            // newNode.parentNode.insertBefore(textNode, newNode.nextSibling)
            newRange.setStartAfter(newNode);
            newRange.collapse(true);
            selection.removeAllRanges();
            selection.addRange(newRange);
        } else {
            // 선택된 텍스트가 없는 경우, 태그를 현재 커서 위치에 추가
            newNode = document.createElement(tag);
            // 태그를 생성하고 range에 삽입
            newNode.innerHTML = " "; // 기본 내용이 없을 경우 공백 추가
            range.insertNode(newNode);
            range.setStartAfter(newNode);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }       
    };

    return (
        <>
            <button onClick={() => wrapWithTag("sup")}>Up</button>
            <button onClick={() => wrapWithTag("sub")}>Down</button>
            <button onClick={() => console.log(textRef.current.innerHTML)}>Baam!</button>
            <TextEditorStyled
                ref={textRef}
                contentEditable={`true`}
                suppressContentEditableWarning={`true`}
                // onInput={({target}) => {setText(target.innerHTML)}}
            ></TextEditorStyled>
        </>
    );
};

export default TextEditor;
